import React from 'react';
import { Tabs, Tab, Box, Button, Typography, TextField, Paper, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Grid, MenuItem, Dialog, DialogTitle, DialogContent } from '@mui/material';
import Client from '../Client';
import Config from '../ClientConfig';
import BackofficeReportsApi from './backofficeReportsApi';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

class PurchaseOrderUI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      client: new Client ( "none" ),
      tabIndex: 0,
      purchaseOrders: [],
      productEntries: [],
      orderData: {
        type: '',
        promisedDate: '',
        location: '',
        description: '',
        supplier: '',
        PurchaseOrderProductEntry_po: []
      },
      tabs: ['Orders List', 'New Order'], 
      selectedOrder: null,
      showDetailDialog: false,
      internalSupplier: 1,
      location: 0,
      locations: [{'iref': 0, 'name': "Select Location"}]
    };
    
    this.getData = this.getData.bind(this);
    this.selectLocation = this.selectLocation.bind(this);
    this.fetchPurchaseOrders = this.fetchPurchaseOrders.bind(this);
  }

  componentDidMount() {
    this.fetchPurchaseOrders();
    this.getData ();
  }

  fetchPurchaseOrders = (locationId = null) => {
    const queryData = {
      "type": 0,
    };
    if (locationId) {
      queryData.location = locationId;
    }
    let data = this.state.client.getData(Config.API_URL_PURCHASE_ORDERS, queryData);
    // console.log(data);
    if ( data ) {
      let checks = [];
      if (Array.isArray(data)) {
        checks = data;
      } else if (Array.isArray(data.purchaseOrder)) {
      checks = data.purchaseOrder;
    } else if (data.purchaseOrder) {
      checks = [data.purchaseOrder];
    }

      this.setState({ purchaseOrders: checks });
    }
  };

  getData () {
    let psiData = this.state.client.getData(Config.API_URL_PRODUCT_SUPPLIER_INFO, {"active": 1});
    if (psiData) {
      this.setState({ psiData: psiData });
    }
    let queryData = {
      // "centralSupply": 1,
      "status": 2,
      "isPurchased": 1,
      "orderBy_name": 1,
      // "supplier": 2
    };
    let data = this.state.client.getData(Config.API_URL_PRODUCT, queryData);

    if (data && psiData) {
      const quantityMultiplierMap = {};
      const psiActiveMap = {};
      const centralSupplyMap = {};
      psiData.productSupplierInfo.forEach(info => {
        if (info.preferred) {  // or your preferred logic
          quantityMultiplierMap[info.product.iref] = info.quantityMultiplier;
          psiActiveMap[info.product.iref] = info.active;
          centralSupplyMap[info.product.iref] = info.centralSupply;
        }
      });
      const products = data.products || {};
      const productEntries = Object.keys(products)
        .map((key, index) => {
          const fData = data.products[key];
          return {
            productId: fData.iref,     // might be duplicated
            productName: fData.name,
            unit: fData.unitType,
            inputQuantity: '',
            quantity: 0,
            reactKey: `${fData.iref}-${key}`,
            active: psiActiveMap[fData.iref],
            centralSupply: centralSupplyMap[fData.iref],
            quantityMultiplier: quantityMultiplierMap[fData.iref] ?? 1,  // default 1 if none
          };
        });

      let configData = { "key": "INTERNAL_SUPPLIER_COMPANY_IREF" };
      let supplierConfig = this.state.client.getData(Config.API_URL_CONFIG_SALESAPP, configData);
      let internalSupplier = 1;
      if (supplierConfig) {
        internalSupplier = supplierConfig.SalesAppConfigs[0]?.value;
      };
      this.setState({ products, productEntries, internalSupplier });
    }
    else {
      alert('Failed to load products.');
    }
  
    let locations = BackofficeReportsApi.getLocations(this.state.client);
    this.setState ( { locations: locations.locations });
  };

  handleLocationFilterChange = (e) => {
    const locationId = e.target.value;
    this.setState({ selectedLocationFilter: locationId }, () => {
      this.fetchPurchaseOrders(locationId);
    });
  };

  selectLocation = (event) => {
    this.setState (
      {location: event.target.value},
      function(){
        this.handleOrderChange('location', event.target.value);
      }
    );
  }

  handleChange = (event, newValue) => {
    this.setState({ tabIndex: newValue });
  };

  handleOrderChange = (field, value) => {
    this.setState(prev => ({
      orderData: {
        ...prev.orderData,
        [field]: value
      }
    }));
  }

  handleQuantityChange = (index, value) => {
   const productEntries = [...this.state.productEntries];
    const entry = productEntries[index];
    const inputQty = parseFloat(value) || 0;
    entry.inputQuantity = value;
    entry.quantity = inputQty * entry.quantityMultiplier;
    this.setState({ productEntries });
  }

  handleSubmit = () => {
    const { orderData, productEntries, internalSupplier } = this.state;
    // Basic validation for required fields
    if (!orderData.promisedDate || !orderData.location) {
      alert('Please fill in both Date and Location before submitting.');
      return;  // stop submission
    }
    const filteredProducts = productEntries
      .filter(p => p.quantity && !isNaN(p.quantity) && parseFloat(p.quantity) > 0)
      .map(p => ({
        product: p.productId,
        unit: p.unit,
        quantity: parseFloat(p.quantity)
      }));
      
    // Prevent submission if no valid lines
    if (filteredProducts.length === 0) {
      alert("Please enter at least one product line with quantity > 0.");
      return;
    }

    const now = new Date();
    const createdOn = now.toISOString();               // e.g. "2025-06-21T13:45:30.000Z"
    const documentDate = now.toISOString().split('T')[0];  // e.g. "2025-06-21"
    const type = 0;
    const supplier = internalSupplier;

    const payload = {
      ...orderData,
      type,
      supplier,
      createdOn,
      documentDate,
      PurchaseOrderProductEntry_po: filteredProducts
    };
    // console.log(JSON.stringify(payload));
    const result = this.state.client.pushData(Config.API_URL_PURCHASE_ORDERS, payload);
    if (result && result.iref) {
      alert("Order saved!");
      this.setState(prev => ({
        orderData: { type: 0, promisedDate: '', location: '', supplier: 2, description: '' },
        productEntries: prev.productEntries.map(p => ({ ...p, quantity: '', inputQuantity: '' })),
        location: 0
      }));
      this.setState({ tabIndex: 0 });
      this.fetchPurchaseOrders();
    } else {
      console.error('Save failed', result);
      const errorMessage = result?.message || "Save failed.";
      alert(errorMessage);
    }
  };
  
  openOrderDetail = (po) => {
    this.setState({ selectedOrder: po, showDetailDialog: true });
  };

  closeOrderDetail = () => {
    this.setState({ showDetailDialog: false, selectedOrder: null });
  };

  renderOrderList = () => {
    // console.log(this.state.purchaseOrders);
    let locations = [{'iref': 0, 'name': "Select Location"}];
    if (this.state.locations){
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];
        let myData = {'iref': fData.iref, 'name': fData.name};
        locations.push ( myData );
      });
    }
    return (
      <Paper
          elevation={1}
          sx={{
            p: { xs: 0.75, sm: 1 },
            height: '100%',
            minHeight: 0,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            borderRadius: '14px',
          }}
        >
          <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          {/* <Typography variant="h6">Purchase Orders</Typography> */}
          <TextField 
            id="standard-select-location"
            select
            required
            // label="Select Location"
            defaultValue="0"
            // helperText="Select Location"
            variant="standard"
            sx={{
              width: { xs: '100%', sm: 220 },
              mb: 0.75,
              '& .MuiInputBase-root': {
                height: 34,
                borderRadius: '12px',
              },
              '& .MuiInputBase-input': {
                fontSize: {
                  xs: '16px',
                  sm: '0.84rem',
                },
              },
            }}
            onChange={this.handleLocationFilterChange}
          >
              {locations.map((option) => (
              <MenuItem key={option.iref} value={option.iref}>
                {option.name}
              </MenuItem>
            ))}
          </TextField>
          <TableContainer
            component={Paper}
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: 'auto',
              borderRadius: '12px',
            }}
          >
            <Table
              size="small"
              stickyHeader
              sx={{
                tableLayout: 'fixed',
                width: '100%',
                '& .MuiTableCell-stickyHeader': {
                  backgroundColor: '#f8fafc',
                  zIndex: 3,
                },
                '& .MuiTableCell-root': {
                  py: { xs: 0.45, sm: 0.65 },
                  px: { xs: 0.5, sm: 0.9 },
                  fontSize: { xs: '0.74rem', sm: '0.86rem' },
                },
              }}
            >
              <TableHead sx={{'& .MuiTableCell-root': {fontWeight: 'bold'}}}>
                <TableRow>
                  <TableCell sx={{ py: 0.5, textAlign: 'center' }}>IREF</TableCell>
                  <TableCell sx={{ py: 0.5 }}>Date</TableCell>
                  <TableCell sx={{ py: 0.5 }}>Promised Date</TableCell>
                  <TableCell sx={{ py: 0.5 }}>Location</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(this.state.purchaseOrders || []).map((po, idx) => (
                  <TableRow key={idx} onClick={() => this.openOrderDetail(po)} style={{ cursor: 'pointer' }}>
                    <TableCell sx={{ py: 0.5, textAlign: 'center' }}>{po.iref || po.id}</TableCell>
                    <TableCell sx={{ py: 0.5 }}>{po.documentDate}</TableCell>
                    <TableCell sx={{ py: 0.5 }}>{po.promisedDate}</TableCell>
                    <TableCell sx={{ py: 0.5 }}>{po.location?.name || po.location?.uid || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>
    );
  };

  renderNewOrderForm = () => {
    const { orderData, productEntries } = this.state;
    const activeEntries = this.state.productEntries
      .map((e, i) => ({ ...e, __idx: i }))           // keep original index
      .filter(p => p.active === true && p.centralSupply === true);
    let locations = [{'iref': 0, 'name': "Select Location"}];
    if (this.state.locations){
      Object.keys(this.state.locations).forEach(key => {
        let fData = this.state.locations[key];
        let myData = {'iref': fData.iref, 'name': fData.name};
        locations.push ( myData );
      });
    }
    const unitTypeMap = { 0: 'pc', 1: 'kg' };
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const minDate = `${yyyy}-${mm}-${dd}`;

    const maxDateObj = new Date(today);
    maxDateObj.setDate(maxDateObj.getDate() + 30);
    const yyyyMax = maxDateObj.getFullYear();
    const mmMax = String(maxDateObj.getMonth() + 1).padStart(2, '0');
    const ddMax = String(maxDateObj.getDate()).padStart(2, '0');
    const maxDate = `${yyyyMax}-${mmMax}-${ddMax}`;

    return (
     <Paper
        elevation={1}
        sx={{
          p: { xs: 0.75, sm: 1 },
          height: '100%',
          minHeight: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '14px',
        }}
      >
        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <Grid
            container
            spacing={1}
            sx={{
              flexShrink: 0,
              mb: 0.75,
              px: 0.25,
              alignItems: 'center',
            }}
          >
            <Grid item xs={12} sm={6}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  label="Promised Date"
                  value={orderData.promisedDate ? dayjs(orderData.promisedDate) : null}
                  onChange={(newValue) => {
                    const formattedDate = newValue ? newValue.format('YYYY-MM-DD') : '';
                    this.handleOrderChange('promisedDate', formattedDate);
                  }}
                  minDate={dayjs(minDate)}
                  maxDate={dayjs(maxDate)}
                  inputFormat="DD.MM.YYYY"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      sx={{
                        width: '100%',
                        '& .MuiInputBase-root': {
                          height: 34,
                          borderRadius: '12px',
                        },
                        '& .MuiInputBase-input': {
                          fontSize: {
                            xs: '16px',
                            sm: '0.84rem',
                          },
                        },
                      }}
                      InputLabelProps={{ shrink: true }}
                    />
                  )}
                  required
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                  id="standard-select-location"
                  select
                  required
                  // label="Select Location"
                  defaultValue="0"
                  // helperText="Select Location"
                  variant="standard"
                  sx={{
                    width: '100%',
                    pt: { xs: 0, sm: 1 },
                    '& .MuiInputBase-root': {
                      height: 34,
                      borderRadius: '12px',
                    },
                    '& .MuiInputBase-input': {
                      fontSize: {
                        xs: '16px',
                        sm: '0.84rem',
                      },
                    },
                  }}
                  onChange={this.selectLocation}
                >
                    {locations.map((option) => (
                    <MenuItem key={option.iref} value={option.iref}>
                      {option.name}
                    </MenuItem>
                  ))}
                </TextField>
            </Grid>
          </Grid>
          {/* <Typography variant="subtitle1" gutterBottom>Products</Typography> */}
          <TableContainer
            component={Paper}
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: 'auto',
              borderRadius: '12px',
            }}
          >
            <Table
              size="small"
              stickyHeader
              sx={{
                minWidth: 420,
                tableLayout: 'fixed',
                '& .MuiTableCell-stickyHeader': {
                  backgroundColor: '#f8fafc',
                  zIndex: 3,
                },
                '& .MuiTableCell-root': {
                  py: { xs: 0.35, sm: 0.5 },
                  px: { xs: 0.4, sm: 0.6 },
                  fontSize: { xs: '0.72rem', sm: '0.84rem' },
                },
              }}
            >
              <TableHead sx={{'& .MuiTableCell-root': {fontWeight: 'bold'}}}>
                <TableRow>
                  <TableCell sx={{ py: 0.25, px: 0.5, whiteSpace: 'normal', width: '45%', textAlign: 'left' }}>Product</TableCell>
                  <TableCell sx={{ py: 0.25, px: 0.5, whiteSpace: 'normal', width: '20%', textAlign: 'right' }}>Input Quantity</TableCell>
                  <TableCell sx={{ py: 0.25, px: 0.5, whiteSpace: 'normal', width: '20%', textAlign: 'right' }}>Quantity</TableCell>
                  <TableCell sx={{ py: 0.25, px: 0.5, whiteSpace: 'normal', width: '15%', textAlign: 'center' }}>Unit</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {activeEntries.map((entry, index) => (
                  <TableRow key={entry.productId}>
                    <TableCell sx={{ py: 0.25, px: 0.5, whiteSpace: 'normal', width: '45%', textAlign: 'left' }}>{entry.productName}</TableCell>
                    <TableCell sx={{ py: 0.25, px: 0.5, whiteSpace: 'normal', width: '20%', textAlign: 'right' }}>
                      <TextField
                        type="number"
                        size="small"
                        value={entry.inputQuantity}
                        onChange={e => {
                          const val = e.target.value;
                          if (/^\d*$/.test(val)) {
                            this.handleQuantityChange(entry.__idx, val);
                          }
                        }}
                        inputProps={{ step: '0.001', inputMode: 'decimal', min: 0, style: { textAlign: 'right' } }}
                        InputProps={{
                          sx: {
                            py: 0.2,
                            height: 30,
                            width: { xs: 72, sm: 90 },
                            fontSize: { xs: '1rem', sm: '0.9rem' },
                            backgroundColor: entry.quantityMultiplier > 1 ? '#fff3cd' : 'inherit',
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ py: 0.25, px: 0.5, whiteSpace: 'normal', width: '20%', textAlign: 'right' }}>
                      <TextField
                        size="small"
                        value={entry.quantity.toLocaleString()}
                        inputProps={{ step: '0.001', inputMode: 'decimal', min: 0, style: { textAlign: 'right' } }}
                        InputProps={{
                          readOnly: true,
                          sx: {
                            py: 0.2,
                            height: 30,
                            width: { xs: 72, sm: 90 },
                            fontSize: { xs: '0.78rem', sm: '0.9rem' },
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell sx={{ py: 0.25, px: 0.5, whiteSpace: 'normal', width: '15%', textAlign: 'center' }}>{unitTypeMap[entry.unit]}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Button
            variant="contained"
            color="primary"
            sx={{
              flexShrink: 0,
              mt: 0.75,
              minWidth: { xs: '100%', sm: 200 },
              width: { xs: '100%', sm: 'fit-content' },
              alignSelf: 'center',
              px: 3,
              height: 34,
              borderRadius: '12px',
              textTransform: 'none',
              fontWeight: 750,
            }}
            onClick={this.handleSubmit}
          >
            Save Order
          </Button>
        </Box>
      </Paper>
    );
  };

  renderOrderDetailDialog = () => {
    const { selectedOrder } = this.state;
    if (!selectedOrder) return null;
    const unitTypeMap = { 0: 'pc', 1: 'kg' };
    // console.log(selectedOrder);
    return (
      <Dialog open={this.state.showDetailDialog} onClose={this.closeOrderDetail} maxWidth="md" fullWidth>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Order Detail - {selectedOrder.iref || selectedOrder.id}
          <IconButton
            aria-label="close"
            onClick={this.closeOrderDetail}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography>Document Date: {selectedOrder.documentDate}</Typography>
          <Typography>Promised Date: {selectedOrder.promisedDate}</Typography>
          <Typography>Location: {selectedOrder.location?.name || '-'}</Typography>
          <Typography>Supplier: {selectedOrder.supplier?.name || '-'}</Typography>

          {selectedOrder.PurchaseOrderProductEntry_po?.length > 0 && (
            <Box mt={2}>
              {/* <Typography variant="subtitle1">Products</Typography> */}
              <Table size="small">
                <TableHead sx={{'& .MuiTableCell-root': {fontWeight: 'bold'}}}>
                  <TableRow>
                    <TableCell>Product</TableCell>
                    <TableCell sx={{ textAlign: 'center' }}>Unit</TableCell>
                    <TableCell sx={{ textAlign: 'right' }}>Quantity</TableCell>
                    {/* <TableCell>AccountingQty</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedOrder.PurchaseOrderProductEntry_po.map((line, idx) => (
                    <TableRow key={idx}>
                      <TableCell>
                        {this.state.productEntries.find(p => String(p.productId) === String(line.product.iref))?.productName || line.product.iref || '-'}
                      </TableCell>
                      <TableCell sx={{ textAlign: 'center' }}>
                        {unitTypeMap[this.state.productEntries.find(p => String(p.productId) === String(line.product.iref))?.unit] || '-'}
                      </TableCell>
                      <TableCell sx={{ textAlign: 'right' }}>{line.quantity.toLocaleString()}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Box>
          )}
        </DialogContent>
      </Dialog>
    );
  };

  render() {
    const { tabIndex, tabs } = this.state;

    return (
      <Box
        sx={{
          width: '100%',
          height: '100%',
          maxHeight: '100%',
          minHeight: 0,
          minWidth: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          bgcolor: 'background.default',
        }}
      >
        <Paper
          elevation={0}
          sx={{
            flexShrink: 0,
            borderRadius: '12px',
            border: '1px solid rgba(15, 23, 42, 0.08)',
            overflow: 'hidden',
            mb: 0.75,
          }}
        >
          <Tabs
            value={tabIndex}
            onChange={this.handleChange}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            sx={{
              minHeight: { xs: 36, sm: 40 },
              '& .MuiTabs-indicator': {
                height: 2,
              },
              '& .MuiTab-root': {
                minHeight: { xs: 36, sm: 40 },
                textTransform: 'none',
                fontWeight: 700,
                fontSize: { xs: '0.75rem', sm: '0.84rem' },
                px: { xs: 1, sm: 1.4 },
              },
            }}
          >
            {tabs.map((label, idx) => (
              <Tab key={idx} label={label} />
            ))}
          </Tabs>
        </Paper>

        <Box
          sx={{
            flex: 1,
            minHeight: 0,
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          {tabIndex === 0 ? this.renderOrderList() : this.renderNewOrderForm()}
        </Box>

        {this.renderOrderDetailDialog()}
      </Box>
    );
  }
}

export default PurchaseOrderUI;
